<template>
  <com-page>
    <com-card>
      <el-descriptions title="基本信息" :column="4">
        <el-descriptions-item label="套餐卡编号">{{ detail.number }}</el-descriptions-item>
        <el-descriptions-item label="套餐卡名称">{{ detail.name }}</el-descriptions-item>
        <el-descriptions-item label="功率上限（w）">{{ detail.limitMaxPower }}</el-descriptions-item>
        <el-descriptions-item label="关联小区">
          <el-button type="text" style="padding: 2px 7px" @click="checkRelatedCommunities">查看</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="套餐类型">
          <div
            style="margin-right: 5px;"
            v-for="item in detail.monthCardDurationTypeList"
            :key="item"
          >{{ typeMap[item] }}；</div>
        </el-descriptions-item>
        <el-descriptions-item label="状态">{{ statusMap[detail.status] }}</el-descriptions-item>
        <el-descriptions-item label="已售数量">{{ detail.soldCount }}</el-descriptions-item>
        <el-descriptions-item label="销售金额">{{ detail.soldAmount }}</el-descriptions-item>
        <el-descriptions-item label="退款数量">{{ detail.refundCount }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{ detail.refundAmount }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detail.refCreateUserName }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime | timeFormate }}</el-descriptions-item>
      </el-descriptions>
    </com-card>

    <com-card style="margin-top: 20px;">
      <div style="margin-bottom: 70px;" v-if="detail.monthPlanList.length">
        <el-descriptions title="月卡" :column="4"></el-descriptions>
        <el-table :data="detail.monthPlanList">
          <el-table-column prop="planName" label="套餐名称"></el-table-column>
          <el-table-column prop="minute" label="套餐时长"></el-table-column>
          <el-table-column prop="money" label="套餐价格"> </el-table-column>
          <el-table-column prop="soldCount" label="已售数量"> </el-table-column>
          <el-table-column prop="giveCount" label="赠送数量"> </el-table-column>
          <el-table-column prop="soldAmount" label="销售金额"> </el-table-column>
          <el-table-column prop="refundCount" label="退款数量"> </el-table-column>
          <el-table-column prop="refundAmount" label="退款金额"> </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openGiftDialog(scope.row)">赠送</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-bottom: 70px;" v-if="detail.seasonPlanList.length">
        <el-descriptions title="季卡" :column="4"></el-descriptions>
        <el-table :data="detail.seasonPlanList">
          <el-table-column prop="planName" label="套餐名称"></el-table-column>
          <el-table-column prop="minute" label="套餐时长"></el-table-column>
          <el-table-column prop="money" label="套餐价格"> </el-table-column>
          <el-table-column prop="soldCount" label="已售数量"> </el-table-column>
          <el-table-column prop="giveCount" label="赠送数量"> </el-table-column>
          <el-table-column prop="soldAmount" label="销售金额"> </el-table-column>
          <el-table-column prop="refundCount" label="退款数量"> </el-table-column>
          <el-table-column prop="refundAmount" label="退款金额"> </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openGiftDialog(scope.row)">赠送</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-bottom: 70px;" v-if="detail.yearPlanList.length">
        <el-descriptions title="年卡" :column="4"></el-descriptions>
        <el-table :data="detail.yearPlanList">
          <el-table-column prop="planName" label="套餐名称"></el-table-column>
          <el-table-column prop="minute" label="套餐时长"></el-table-column>
          <el-table-column prop="money" label="套餐价格"> </el-table-column>
          <el-table-column prop="soldCount" label="已售数量"> </el-table-column>
          <el-table-column prop="giveCount" label="赠送数量"> </el-table-column>
          <el-table-column prop="soldAmount" label="销售金额"> </el-table-column>
          <el-table-column prop="refundCount" label="退款数量"> </el-table-column>
          <el-table-column prop="refundAmount" label="退款金额"> </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openGiftDialog(scope.row)">赠送</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </com-card>

    <RelatedCommunities ref="relatedCommunitiesRef"></RelatedCommunities>
    <gift-dialog ref="giftDialogRef" @update="getDetail"></gift-dialog>
  </com-page>
</template>

<script>
import { monthCardDetailApi } from '@/api/package-card'
import RelatedCommunities from './components/related-communities'
import giftDialog from './components/gift-dialog.vue'

export default {
  components: { RelatedCommunities, giftDialog },
  data() {
    return {
      code: '',
      detail: {
        monthPlanList: [],
        seasonPlanList: [],
        yearPlanList: []
      },
      statusMap: {
        0: '未启用',
        1: '已启用'
      },
      typeMap: {
        1: '月卡',
        2: '季卡',
        3: '年卡'
      }
    }
  },

  created() {
    this.code = this.$route.query.id
    console.log('route :>> ', this.detail)
    this.getDetail()
  },

  methods: {
    getDetail() {
      monthCardDetailApi({code: this.code}).then((res) => {
        this.detail = res.data.monthCard
      })
    },

    checkRelatedCommunities() {
      this.$refs.relatedCommunitiesRef.open(this.detail)
    },

    openGiftDialog(item) {
      this.$refs.giftDialogRef.open(item)
    }
  },
}
</script>

<style lang="scss" scoped></style>
